function About() {
  return (
    <>
    <main class="flex-shrink-0">
      <div class="container">
        <h2 class="mt-5">About</h2>
        <p class="lead">
          Credits, etc.
        </p>
      </div>
    </main>
    </>
  );
}

export default About;
